import React from "react";

function ErrorSummary(props) {
    let {errors = []} = props;

    return <ul>
        {
            Object.entries(errors).map(([key, list]) => {

                if (Array.isArray(list)) {
                    return <li key={key}>{list.join(',')}</li>
                } else {
                    return <ErrorSummary errors={list}/>
                }

            })
        }
    </ul>;
}

export default ErrorSummary;